module.exports = __webpack_public_path__ + "static/media/SP_S_Fashion_Roseto Sand_DK Grey.3bbc9ee8.png";